import { LocationSummary } from './LocationSummary'
import { LocationDetails } from './LocationDetails'
import { ChildListItem } from '../interfaces'

export const getLocationChildrenRows = (
  locationName: string,
  childList: ChildListItem[],
  level: number,
  addChild: (parentId: number) => void,
  editItem: (rowId: number) => void,
  deactivateItem: (rowId: number) => void
) =>
  childList.map(child => ({
    id: child.id,
    summary: (
      <LocationSummary
        parentName={locationName}
        name={child.name}
        locationUnitTypeName={child.locationUnitType.name}
        active={child.active}
        childrenCount={child.childList?.length || 0}
      />
    ),
    details: (
      <LocationDetails
        parentName={child.name}
        childList={child.childList}
        level={level + 1}
        addChild={addChild}
        editItem={editItem}
        deactivateItem={deactivateItem}
      />
    ),
    borderLeftColor: level === 0 ? '#0970E6' : level === 1 ? '#ff9900' : '#33691e'
  }))
